import { NavItemEnum } from '../../../constants/routing/NavItems';
export const SCREENS = Object.assign({}, NavItemEnum, {
  COMPARE: 'feature-compare',
  ERROR: 'error',
  INTERSTITIAL: 'interstitial',
  PRODUCTS_PLANS: 'products-plans',
  SUITE_STARTER: 'suite-starter',
  HUBSPOT_ON_CREDITS: 'hubspot-on-credits',
  FLEX_SEATS_AND_CREDITS: 'flex-seats-and-credits',
  DEFAULT: 'default',
  SINGLE_PAGE: 'single-page'
});
export const SUBSCREENS = {
  DEFAULT: 'default',
  ADD_SEATS: 'add-seats',
  ADD_REMAINING_SEATS: 'add-remaining-seats',
  ONBOARDING: 'onboarding',
  BUY_ADDITIONAL_MARKETING_CONTACTS: 'buy-additional-marketing-contacts',
  BUY_ADDITIONAL_SEATS: 'buy-additional-seats'
};